import React, { PropsWithChildren } from 'react'

import {
  Container,
  ContainerWithFade,
  ContainerBottonTop,
  ContainerRightLeft,
  ContainerLeftRight,
} from './styles'
import { Header } from '../header'

interface IBaseContainer {
  headerTitle?: string
  onClickArrowLeft: () => void
  animationType: 'fade' | 'left-right' | 'right-left'
}
export const BaseContainer = ({
  headerTitle,
  children,
  onClickArrowLeft,
  animationType,
}: PropsWithChildren<IBaseContainer>) => (
  <Container>
    <Header onBackClick={onClickArrowLeft} title={headerTitle} />
    {animationType === 'left-right' && <ContainerLeftRight>{children}</ContainerLeftRight>}
    {animationType === 'right-left' && <ContainerRightLeft>{children}</ContainerRightLeft>}
    {animationType === 'fade' && <ContainerWithFade>{children}</ContainerWithFade>}
  </Container>
)
export const BaseContainerRoot = ({ children }: { children: React.ReactNode }) => (
  <ContainerBottonTop>{children}</ContainerBottonTop>
)
